import { render, staticRenderFns } from "./Pastsessiondetail.vue?vue&type=template&id=67fcb764&"
import script from "./Pastsessiondetail.vue?vue&type=script&lang=js&"
export * from "./Pastsessiondetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports